import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';
import { updateUser } from '../../reducers/userReducer';
import AnimatedPage from "../../components/AnimatedPage";
import { toggleModal } from "../../reducers/modalReducer";
import { BILLING, COMPANY } from "../../constants/routes";
import Certification from "../../components/Certification";
import { refreshCompanies } from '../../reducers/companiesReducer';
import { getRequest, postRequest, showMessage } from "../../config";
import HeadingSubheadingContent from "../../components/HeadingSubheadingContent";
import { setCompany } from '../../reducers/companyReducer';


export default function Dashboard() {

	const dispatch = useDispatch();
	const location = useLocation();
	const navigation = useNavigate();

	const user = useSelector(state => state.user);
	const modal = useSelector(state => state.modal);
	const companies = useSelector(state => state.companies);
	const [noCompanies, setNoCompanies] = useState(false);
	const [profileClass, setProfileClass] = useState('client-profile');

	const SEE_MORE = {
		icon: <svg width="83" height="83" viewBox="0 0 84 83" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z" fill="#4A67FF" />
			<path d="M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z" fill="#4A67FF" />
			<path d="M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z" fill="#4A67FF" />
			<path d="M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z" fill="#4A67FF" />
		</svg>,
		title: <>Your Company<br /> Dashboard</>,
		points: [
			'All your modules in one place',
			'Overall completeness and risk scores',
			'Overall certification (broze/silver/gold)',
			'At-a-glance module progress and status',
			'Access to reports for each module',
			'Easy one-stop shop for your clients and Investors to work collaboratively with you',
		],
		image: require('../../../images/landingpage/banner1.png'),
		imageStyle: { height: '90%', width: '94%' }
	};

	useEffect(() => {
		if (dispatch) {
			dispatch(setCompany({}))
		}
	}, [dispatch])

	useEffect(() => {
		let isAgreeWithDisclaimer = localStorage.getItem('isAgreeWithDisclaimer');
		if (Object.keys(user).length && user.isAgreeWithDisclaimer === false && !isAgreeWithDisclaimer) {
			dispatch(toggleModal({ open: 'disclaimerModal' }));
		}
		if (user && user['type'] == 'Superflow') updateUserType();
	}, [user])

	const updateUserType = async () => {
		let res = await postRequest('/user/updateUserType', { type: 'User' });
		if (res['code'] != '200') showMessage(res['message']);
	};

	useEffect(() => {
		getCompanies();
		if (location.pathname.includes('gDriveCallBack')) connectGDrive();
		else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
		else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
		if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile');

		let isWorkflowTab = localStorage.getItem('isWorkflowTab');
		if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');

		let isManualAdd = localStorage.getItem('isManualAdd');
		if (isManualAdd) localStorage.removeItem('isManualAdd');
	}, []);

	const getCompanies = async () => {
		let response = await getRequest(`/modules/my-profile`);
		if (response['body']) {
			let { user, companies } = response['body'];
			let groups = companies.filter(({ group }) => group == 'Parent');
			let standard = companies.filter(({ group }) => group != 'Parent');
			companies = groups.concat(standard);

			if (companies.length == 0) setNoCompanies(true);

			dispatch(updateUser(user));
			dispatch(refreshCompanies(companies));
		};
	};

	const connectGDrive = async () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectGDrive`, { code, companyId });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}#repository`), 1000);
		}
	};

	const connectDropBox = async () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectDropBox`, { code, companyId });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}`), 1000);
		};
	};

	const connectSharePoint = async () => {
		let { code, state: companyId, client_info } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectSharePoint`, { code, companyId, client_info });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}`), 1000);
		};
	};

	const urlSearchData = searchString => {
		if (!searchString) return {};
		return searchString.substring(1).split('&').reduce((result, next) => {
			let pair = next.split('=');
			result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
			return result;
		}, {});
	};

	const handleAddCompany = async () => {
		await localStorage.removeItem('isDemoChecklist');
		await localStorage.removeItem('isPartnerChecklist');
		localStorage.removeItem('testType');
		dispatch(toggleModal({ open: 'addCompany' }));
	};

	const showCompanyDetails = (company) => {
		return <>
			<div className="df w400px">
				<div className="df fdc jcfs tal">
					<h4 className='fs1-25rem c15 mb1rem w300px'>{company['cName']}</h4>
					<span className='df w300px'>
						{company['subscription']
							? <h2 className="fs1-25rem c7 mra tal mr1rem ttu">
								{((company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && (company['advisors'] || company['investors']) && company['subscription'] == 'Pro')
									? 'PRO'
									: <>{company['subscription']}</>
								}</h2>
							: <h2 className="fs1-25rem c8 mr1rem tal">INACTIVE</h2>
						}
						{company['subscription']
							? ["Free", "Lite"].includes(company['subscription']) ? <Link
								to={BILLING.replace(":id", company['_id'])}
								className={`${user['role'] == 'Guest' && 'op20 pen '} df aic bg4 br50px px1-5rem py0-5rem jcc cp c1 mr0-5rem fs0-75rem fw500 w100px`}
							>
								Upgrade
							</Link> : null
							: <div className='pr'>
								<Link
									data-testid="subscribeNow"
									to={company?.['creatorId']?.['createdBy']?.['role'] && ['advisor', 'investor'].includes(company?.['creatorId']?.['createdBy']?.['role'].toLowerCase()) ? `${BILLING.replace(":id", company['_id'])}/pro/${company?.['creatorId']?.['createdBy']?.['role'].toLowerCase()}` : BILLING.replace(":id", company['_id'])}
									className="tac bg4 br50px bw2px bss py0-5rem px1rem bsbb aic cp bo4 c1 fs0-75rem mr0-5rem"
								>
									Subscribe
								</Link>
								<span>
								</span>
							</div>
						}
						<Link data-tooltip={"Company Settings"} to={`/company/${company['_id']}#company-settings`} className={`tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ${(!company["subscription"]) && "pen"}`}>
							Settings
						</Link>
					</span>
				</div>
			</div >
			<div className="df m1rem jcc">
				<div className="df jcse w60px mr2rem">
					<span className="w20 df jcc username-area tac mr2rem">
						<div className="df fdc aic">

							{company?.['creatorId'] && company?.['creatorId']?.['profile']
								? <img src={company['creatorId']['profile']} className={`w40px h40px df jcc aic br100 cp bo30 bss bw3px ${profileClass}`} data-tooltip={company['creatorId']['firstName'] ? (company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ?? "")) : "Register to show your name here"} />
								: <span className={`w40px h40px df jcc aic br100 bg3 c0 bw3px bss bo30 c1 ${profileClass}`} data-tooltip={company['creatorId']['firstName'] ? (company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "")) : "Register to show your name here"}>{company['creatorId']['firstName'] ? (company['creatorId']['firstName'][0] + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName']?.[0] : "")) : "?"}</span>
							}
							<span className="ass mt0-5rem fs0-75rem c15">Company <br />Admin</span>
						</div>
					</span>
				</div>

				{company?.['advisorsData'] && company['advisorsData'].length > 0 && company['advisorsData'].filter((adv) => !adv?.['createdBy']).map((advs, index) => {
					return (
						<React.Fragment key={`${advs['_id']}-${index}`}>
							<div className="df jcse w60px mr1rem">
								<span className="w20 df jcc username-area tac">
									<div className="df fdc aic">
										{company?.["creatorId"] && (<>
											{advs["profile"] ? (
												<img src={advs["profile"]} className={`w40px h40px df jcc aic br100 cp mr0 - 5rem client - profile`}
													data-tooltip={(advs?.['firstName'] && advs['firstName']) + " " + (advs?.['lastName'] ? advs?.['lastName'] : "")} />
											) : (
												<span data-tooltip={(advs?.['firstName'] && advs['firstName']) + " " + (advs?.['lastName'] ? advs?.['lastName'] : "")}
													className={`w40px h40px df jcc aic br100 c0  bw3px bss bo29 client - profile`}>
													<>{advs?.['firstName'] && advs['firstName'][0]}{advs?.['lastName']?.[0] ? advs['lastName'][0] : ""}</>
												</span>
											)}
											<span className="ass mt0-5rem fs0-75rem c15">Company <br />Advisor</span>
										</>
										)}
									</div>
								</span>
							</div>
						</React.Fragment>
					)
				})
				}

				{company?.['investorData'] && company['investorData'].length > 0 && company['investorData'].filter((adv) => !adv?.['createdBy']).map((investor, index) => {
					return (
						<React.Fragment key={`${investor['_id']}-${index}`}>
							<div className="df jcse w60px mr1rem">
								<span className="w20 df jcc username-area tac">
									<div className="df fdc aic">
										{company?.["creatorId"] && (<>
											{investor["profile"] ? (
												<img src={investor["profile"]} className={`w40px h40px df jcc aic br100 cp mr0 - 5rem client - profile`}
													data-tooltip={(investor?.['firstName'] && investor['firstName']) + " " + (investor?.['lastName'] ? investor?.['lastName'] : "")} />
											) : (
												<span data-tooltip={(investor?.['firstName'] && investor['firstName']) + " " + (investor?.['lastName'] ? investor?.['lastName'] : "")}
													className={`w40px h40px df jcc aic br100 c0 bw3px bss bo29 client - profile`}>
													<>{investor?.['firstName'] && investor['firstName'][0]}{investor?.['lastName']?.[0] ? investor['lastName'][0] : ""}</>
												</span>
											)}
											<span className="ass mt0-5rem fs0-75rem c15">Company <br />Investor</span>
										</>
										)}
									</div>
								</span>
							</div>
						</React.Fragment>
					)
				})
				}
				{
					(company['group'] && company['group'] !== "Standard") ? <div className="df jcse w60px mr2rem">
						<span className='w20 df username-area type-user mr2rem'>
							<div className="df fdc">
								<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={(company['group'] && company['group'] !== "Standard") ? company['group'] : 'No group'} className={`w40px h40px df jcc aic br100 bg4 c1 bo4 bss bw3px mb1rem ${company['group'] ? 'fs1rem' : 'fs0-75rem'}`}>
									{(company['group'] && company['group'] !== "Standard") ? company['group'][0] : 'N/A'}
								</span>
								<span className="ass mt0-5rem fs0-75rem c15">Group</span>
							</div>
						</span>
					</div> : null
				}


			</div>
			<div className="df jcse aic fdc reprot-btn-dropdowns">
				<Link to={COMPANY.replace(":id", company['_id'])}
					className={`${!company['subscription'] && 'op20 pen '} tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100 td250`}>
					Company Dashboard
				</Link>
			</div>
			<div className="progress-area progress-dashboard" style={{ display: "flex", position: "relative", justifyContent: "center", }}>
				<div className="progress-box ml2rem mr1rem">
					<div className="progress-bar" style={{ width: 100, height: 100 }}>
						<CircularProgressbar
							className={`${company.stats.completionPercent > 67 ? 'green'
								: company.stats.completionPercent > 33 ? 'orange'
									: 'red'}`}
							value={company.stats.completionPercent || 0}
							text={(company.stats.completionPercent || 0) + "%"}
							strokeWidth={18}
							styles={buildStyles({
								strokeLinecap: 'round',
								strokeWidth: '5px',
								textSize: '20px',
								pathTransitionDuration: 0.5,
								trailColor: '#d6d6d6',
								backgroundColor: '#fc7785',
								dominantBaseline: 'ideographic',
							})}
						/>
					</div>
					<div className="bottom-text df fdc tac jcc mt0-5rem">
						<span className="fs1rem fw300 c15">
							Overall
						</span>
						<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
							Completeness
						</span>
					</div>
				</div>
				<div className="progress-box ml2rem mr1rem">
					<div className="progress-bar" style={{ width: 100, height: 100 }}>
						<CircularProgressbar
							className={`${company.stats.riskPercent > 67 ? 'red'
								: company.stats.riskPercent > 33 ? 'orange'
									: 'green'}`}
							value={company.stats.riskPercent || 0}
							text={company.stats.completionPercent ? `${(company.stats.riskPercent || 0)}%` : "0%"}
							strokeWidth={18}
							styles={buildStyles({
								strokeLinecap: 'butt',
								strokeWidth: '5px',
								textSize: '20px',
								pathTransitionDuration: 0.5,
								trailColor: '#d6d6d6',
								backgroundColor: '#fc7785',
								dominantBaseline: 'ideographic',
							})}
						/>
					</div>
					<div className="bottom-text df fdc tac jcc mt0-5rem">
						<span className="fs1rem fw300 c15">
							Overall
						</span>
						<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
							Risk
						</span>
					</div>
				</div>
				{company['subscription'] == 'Pro' &&
					<Link onClick={() => localStorage.setItem('isWorkflowTab', true)} to={`/company/${company['_id']}`} className="cp progress-box ml2rem mr1rem df fdc aic">
						<div className={`progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : company?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`}
							style={{ width: 80, height: 80, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
							<CircularProgressbar
								text={(company?.stats?.workflowCompletionPercent || 0) + "%"}
								styles={buildStyles({
									strokeWidth: '0',
									textSize: '20px',
									trailColor: '#FBFBFB',
									stroke: 'transparent',
									strokeLinecap: 'butt',
									backgroundColor: '#FBFBFB',
									pathTransitionDuration: 0.5,
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<div className="bottom-text df fdc tac jcc mt0-5rem">
							<span className="fs1rem fw300 c15">
								Overall
							</span>
							<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
								Workflow Completeness
							</span>
						</div>
					</Link>
				}
			</div>
			<div className="df jcse mt0-5rem">
				<div className="certificate-area-dashboard">
					{(company['cLevel']) && (company['subscription'] == "Pro" || company['subscription'] == "Pro Plus") &&
						<Link data-tooltip="Certification" to={`/company/${company['_id']}#unaudited-certification`} className="cp">
							<Certification className={'op100'} level={company['subscription'] == "Lite" ? 'None' : company['cLevel']} expiryTimestamp={company['createdAt']} company={company} subscription={company['subscription']} />
						</Link>
					}
				</div>
			</div>
		</>
	};

	return (
		<>
			<AnimatedPage>
				<div className="dashboard-container company-dashboard pt1rem pb1rem df fdc poppins-font-style * ">
					<div className={`pr w100 mb1rem company-bg`}>
						<div className='df jcsb w100 aic top-admin-area' style={{ backgroundColor: '#c5cfff80', borderRadius: '1rem 1rem 0 0', padding: '0.5rem 1rem', }}>
							<div>
								<ul className="df aic lisn">
									<li className="fs14px c15">Company Index</li>
								</ul>
							</div>
							<div className='right-area df'>
								<div className="ass df">
									{/* Owner */}
									<div className="df fs1rem aic">
										<div className='mr1rem tar df fdc'>
											{user?.['firstName'] && <span className="c15 ase">{user?.['firstName'] + " " + (user?.['lastName'] ?? "")}</span>}
											{user?.['companyId']?.['creatorId']?.['_id'] == user['_id'] && <span className={`c3 ase fs0-75rem`}>
												Company Admin
											</span>}
										</div>
										{user?.['firstName'] &&
											<span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`}>
												{user?.['profile']
													? <img src={user?.['profile']} className={`w40px h40px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")} />
													: <span className={`w30px h30px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")}>{user?.['firstName'] ? (user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "")) : "?"}</span>
												}</span>
										}
									</div>
								</div>
							</div>
						</div>
						<div className={` bg1 new-shadow py2rem px3rem mb2rem pr`} style={{ borderRadius: '0 0 1rem 1rem', }}>
							<div className='df fww company-details-area mt2rem'>
								<div className='center-logo-area w100 df jcc fww pr'>
									<h2 className='c15 fs2rem mt1rem tac w100 fw500 pr df aifs jcc'>
										<HeadingSubheadingContent wrapperClass="tac" heading="Company Index" />
									</h2>
								</div>
							</div>
						</div>
					</div>
					<div className='dahboard-tabs'>
						<div className='MuiTabPanel-root' style={{ width: '100%' }}>
							<div className="df fdc">
								<div className='df fdc aic advisor-index mt1rem'>
									<div className="df jcsb pt1rem pr3rem w100 aic">
										{user['email'] != 'temp' && <>
											<div className="df">
												<div onClick={() => handleAddCompany()} className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard">
													<span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
														<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_2656_879)">
																<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
															</g>
															<defs>
																<clipPath id="clip0_2656_879">
																	<rect width="38" height="38" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</span>
													<span className='c15'>Add Company</span>
												</div>
												<div onClick={() => dispatch(toggleModal({ open: 'groupCompanies' }))} className={`${companies && companies.length <= 1 && 'op20 pen '} df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard`}>
													<span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
														<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_2656_879)">
																<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
															</g>
															<defs>
																<clipPath id="clip0_2656_879">
																	<rect width="38" height="38" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</span>
													<span className='c15'>Create Group</span>
												</div>
												{companies && companies.some(c => c.group === 'Parent') && (
													<div onClick={() => dispatch(toggleModal({ open: 'editGroupSelect' }))} className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard">
														<span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
															<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clipPath="url(#clip0_edit_group_btn)">
																	<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																	<path d="M25.5 12.5L23.5 10.5L13 21V23H15L25.5 12.5Z" fill="#FAFAFA" />
																	<path d="M27 11L26 10C25.4 9.4 24.6 9.4 24 10L22.5 11.5L26.5 15.5L28 14C28.6 13.4 28.6 12.6 28 12L27 11Z" fill="#FAFAFA" />
																	<path d="M10 25H28V27H10V25Z" fill="#FAFAFA" />
																</g>
																<defs>
																	<clipPath id="clip0_edit_group_btn">
																		<rect width="38" height="38" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</span>
														<span className='c15'>Edit Group</span>
													</div>
												)}
											</div>
										</>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='dahboard-tabs' style={{ width: '93%', margin: 'auto' }}>
					<div className='MuiTabPanel-root'>
						<div className="pb2rem df fdc">
							<div className='df fdc aic advisor-index'>
								{companies && companies.length > 0
									? companies.map((company, idx) => {
										return (
											<div key={idx} className="dropdown-company-dahboard">
												<div className="dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
													{showCompanyDetails(company)}
												</div>
												{company['childrenCompanies'] && company['childrenCompanies'].length > 0 && <>
													<div className="dropdown-content">
														{company['childrenCompanies'] && company['childrenCompanies'].map((childrenCompany, idx) => {
															return (
																<div key={idx} className="dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
																	{showCompanyDetails(childrenCompany)}
																</div>
															)
														})}
													</div>
												</>}
											</div>
										)
									})
									: <>{noCompanies && <>
										<img className='' src={require('../../../images/no-companies-added.png')} />
										<img className='pa b0 r0 mr2rem mb1rem' src={require('../../../images/ai-no-company-add.png')} />
									</>}</>
								}
							</div>
						</div>
					</div>
				</div>
			</AnimatedPage>

			{/* User Detail */}
			<Modal open={modal['open'] == 'userDetail'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs3rem tac lh1 fw600 mb2rem">Owner Detail</h1>
					<div className='df fdc iic mxa gg0-5rem'>
						<span className='w100' ><b>Name: &nbsp;</b> {user?.firstName + (user?.lastName ?? "")} </span>
						<span className='w100'><b>Email: &nbsp;</b> {user?.email} </span>
						<span className='w100'><b>Role: &nbsp;</b> {user?.role} </span>
					</div>
				</div>
			</Modal>

			{/* See More Popup */}
			<Modal id="keyFeatureSeeMore" open={modal['open'] == 'openSeeMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic" >
				<div className="poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', maxWidth: '1350px' }}>
					<div className='df w100' >
						<div style={{ width: "55%", height: '100%' }}>
							<div className='df w100 mb1rem'>
								<div className="w10 df aic">{SEE_MORE?.icon}</div>
								<div className="w90 fw500 c15 pl1rem df aic" style={{ fontSize: '26px', lineHeight: '37.32px' }}>{SEE_MORE?.title}</div>
							</div>
							{/* custom-list */}
							<ul className=" mt0-5rem" style={{ paddingLeft: '22px' }}>
								{SEE_MORE?.points?.map((objpoints, index) => {
									return (
										<li style={{ lineHeight: '25px', paddingBottom: "3px", paddingTop: "3px", paddingLeft: "20px", borderLeft: '2px solid #D3D9FC', ...SEE_MORE?.liStyle }} className="df fdc fs1rem c14 fs1rem fw400" key={`${objpoints}-${index}`}>
											<div className="pr"><div className="circle"></div>{objpoints}</div>
										</li>
									)
								})}
							</ul>
						</div>
						<div className="df aic jce" style={{ width: '45%' }}>
							<img src={SEE_MORE?.image} className="w70" style={{ objectFit: 'fill' }} />
						</div>
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '650px', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal >
		</>
	);
}